import builder from '../builder';
import DownloadThickBottom from '../../streamline-icons/light/download-thick-bottom.svg';

export default builder('IconDownloadThickBottomLight', DownloadThickBottom);
